import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//基础信息相关API

const examAdministration = {
    major: {
        queryList: config => createAPI('/skillRecognition/ksgl/queryList', 'post', config),
        initCombo: config => createAPI('/skillRecognition/ksgl/initCombo', 'post', config),
        save: config => createAPI('/skillRecognition/ksgl/save', 'post', config),
        deleteById: config => createAPI('/skillRecognition/ksgl/del', 'post', config),
        releaseRecById: config => createAPI('/skillRecognition/ksgl/releaseRecById', 'post', config),
        queryById: config => createAPI('/skillRecognition/ksgl/queryById', 'post', config),
        queryKskcbById: config => createAPI('/skillRecognition/ksgl/queryKskcbById', 'post', config),
    },
};

export default examAdministration;



// WEBPACK FOOTER //
// ./src/api/modules/examAdministration.js